module.exports = __webpack_public_path__ + "img/SchwungImReifen.eb33980e.jpg";